import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlservico = '/service/portal/conteudo/transparencia/faleConosco'

class FaleConoscoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        const categoria = config.categoria ? config.categoria : null
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        this.state = {
            paramCategoria: categoria ? `?categoria=${categoria}` : '',
        }
    }

    getInformacoes() {
        return this.conex.get(urlservico + this.state.paramCategoria)
    }
}

export default FaleConoscoService
